import {pipe, assoc, dissoc, prop, __} from 'ramda'

const renamePropName = <T>(from: string, to: string) => (
  objectToChange: Record<string, any>
): T =>
  pipe(prop(from), assoc(to, __, objectToChange), dissoc(from))(objectToChange)

export default renamePropName
